import { createSelector } from '@ngrx/store';

import * as fromReducers from '../reducers';

export const getContractDetailsState = createSelector(fromReducers.getContractState, (state: fromReducers.ContractState) => state.details);

export const getContractSummaryState = createSelector(getContractDetailsState, fromReducers.getContractSummary);

export const getContractSummarySearchState = createSelector(getContractDetailsState, fromReducers.getContractSummarySearch);

export const getContractRequestFormState = createSelector(getContractDetailsState, fromReducers.getContractRequestForm);
